import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 6594655A-5BB0-43B5-B3BD-CF04D4B59562
 * name roman-numeral-3
 * version: 4.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/roman-numeral-3.svg
 * tags
 * - Alpha / Numeric 
 */
export const RomanNumeral3Icon = createSvgIcon(<><path d="M9 7V9H8V15H9V17H5V15H6V9H5V7H9M14 7V9H13V15H14V17H10V15H11V9H10V7H14M19 7V9H18V15H19V17H15V15H16V9H15V7H19Z" /></>, 'RomanNumeral3Icon');
export default RomanNumeral3Icon